import { Emp } from "./Emp";
import { DAO } from "./DAO";
import { UserInfoDTO } from "./DTOs";
import { API } from "./API";
import { API_ROUTE_auth_admin_login } from "../Routes";

export class EmpDAO {

  static async Select_管理者登入(emp_id: string, emp_pw: string): Promise<Emp[]> {
    let cond = " WHERE (1=1) "
      + " AND " + Cnd.指定idpw(emp_id, emp_pw);

    let data_list = await DAO.Select(Emp, cond);
    return data_list;
  }

  static async Select(): Promise<Emp[]> {
    let cond = " WHERE (1=1) ";
    let data_list = await DAO.Select(Emp, cond);
    return data_list;
  }

  static async FetchByGuid(guid: string): Promise<Emp> {
    let data = await DAO.FetchByGuid(Emp, guid);
    return data;
  }

  static async Insert(data: Emp): Promise<Emp> {
    let refetch_data = await DAO.Insert(Emp, data);
    return refetch_data;
  }

  static async Update(data: Emp): Promise<Emp> {
    let refetch_data = await DAO.Update(Emp, data);
    return refetch_data;
  }

  static async Delete(data: Emp): Promise<number> {
    let effect_rows_cnt = await DAO.DeleteByGuid(Emp, data.guid);
    return effect_rows_cnt;
  }

  static async Login(username: string, password: string): Promise<UserInfoDTO | null> {
    const result = await API.Call_POST(API_ROUTE_auth_admin_login, { username, password });
    if (result.code === API.CODE_OK) {
      return result.data as UserInfoDTO;
    }
    else {
      return null;
    }
  }
}

class Cnd {
  static 指定idpw(emp_id: string, emp_pw: string) {
    return ` (emp_id='${emp_id}' AND emp_pw='${emp_pw}') `;
  }
}